<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets/images/caseCar/banner.png" />
        <div class="banner-title">智能营销平台</div>
      </div>
      
      <div class="container">
        <img src="@/assets/images/marketingPlatform/bg.jpg" class="big-bg"/>
        <div class="wrap-nav">
          <div class="wrap-nav-describe">
             支持建立精细化客户组进行精准营销，也可以根据用户旅程设置自动化营销规则。支持短信、微信等触发渠道，支持H5、优惠券等推送内容，提高新客首单转化，
             降低老客流失率，提高客单价。
          </div>
        </div>
        <div class="content">
          <div class="describe">
            <img src="@/assets/images/marketingPlatform/marketing.png" />
            <div class="vip-box">
              <p>客户筛选与客户组管理</p>
              <p>多维度客户筛选，自定义精准客户组，可查看客户组分析，了解定向人群特征，设计精准营销策略。</p>
            </div>
          </div>
          <div class="describe">
            <div class="error-box">
              <p>自动化营销</p>
              <p>使用功能强大的优惠券引擎打造个性化促销和优惠活动，在各个渠道发放与核销优惠券。配置生命周期触发规则，实现会员生命周期沟通管理，实现与消费者实时互动，确保沟通的高效性。</p>
            </div>
            <img src="@/assets/images/marketingPlatform/marketing2.png" class="error-img" />
          </div>
          <div class="describe" style="margin-left:50px">
            <img src="@/assets/images/marketingPlatform/marketing3.png"  />
            <div class="ugc-box">
              <p>优惠券管理</p>
              <p> 支持自创建或第三方优惠券导入，并且进行有效的规则管理，提高优惠券发送与使用率。</p>
            </div>
          </div>
          <div class="describe">
            <div class="last-box">
              <div class="last-box-p">
                <p>营销活动效果追踪</p>
                <p>
                  对整体营销活动进行全流程追踪，精准到人、动作、事件。通过数据化的分析来了解每个营销过程，从而找到新的效果提高策略。
                </p>
              </div>
            </div>
            <img src="@/assets/images/marketingPlatform/marketing4.png" class="market-img"  />
          </div>
        </div>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {};
  },
  components: {
    navBar,
    footerBar
  },
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  min-width: $min-screen-width;
  margin: 0 auto;
  font-family: Source Han Sans CN;

  .banner {
    position: relative;
    height: 430px;
    overflow: hidden;
    .banner-title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 575px;
    }
  }
  .wrap-nav {
    margin: 0 auto;
    margin-top: 58px;
    // width: 1200px;
    position: relative;
    z-index: 10;

    .wrap-nav-describe {
      margin: 0 auto;
      margin-top: 110px;
      text-align: center;
      width: 990px;
      font-size: $font-size-20;
      line-height: 32px;
      color: #707070;
    }
  }

  p:nth-child(1) {
    font-size: $font-size-20;
    font-weight: bold;
    line-height: 50px;
    color: #464646;
  }
  p:nth-child(2) {
    margin-top: 30px;
    width: 360px;
    font-size: $font-size-18;
    font-family: SourceHanSansCN-Normal;
    line-height: 28px;
    color: #707070;
  }
}

.container {
  height: 3525px;
  position: relative;
  overflow: hidden;
  .big-bg {
    position: absolute;
  }
  .content {
    width: 1200px;
    // height: 3125px;
    position: relative;
    margin: 0 auto;
    .describe {
      display: flex;
      margin-top: 230px;
      position: relative;
      .vip-box {
        padding-left: 60px;
        padding-top: 48px
      }
      .error-box {
        padding-left: 60px;
        padding-right: 270px;
        margin-top: 120px;
      }
      .error-img{
        // width:980px;
        // height:337px;
        margin-top: 120px;
        margin-left: -210px;
      }
      .ugc-box {
        padding-top: 217px;
        padding-left: 60px; 
      }
      .last-box {
        padding-left: 59px; 
        padding-right: 278px; 
        .last-box-p{
            margin-top:100px
        }
      }
      .market-img {
        position: absolute;
        bottom: -342px;
        right: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/marketingPlatform/index.vue